export enum VisitTypeEnum {
    Prn = "prn",
    OnCall = "onCall"
}
